import '../scss/index.scss';

import { gsap } from 'gsap';
import 'liquid-ajax-cart';
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

/* ======================================================================================= */
/* ============================================================================== MAIN NAV */
/* ======================================================================================= */

let menus = document.querySelectorAll('.js--menu');

menus.forEach((slider) => {
  const slider_prod = new Swiper(slider, {
    initialSlide: 0,
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: false,
  });
});

/* ======================================================================================= */
/* =============================================================================== PRODUCT */
/* ======================================================================================= */

let productImages = document.querySelectorAll('.js--product-images');

productImages.forEach((slider) => {
  const slider_feat = new Swiper(slider, {
    modules: [Autoplay],
    initialSlide: 0,
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 500,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
  });
});

/* ======================================================================================= */
/* ================================================================================== CART */
/* ======================================================================================= */

if (window.liquidAjaxCart) {
  const ajaxCart = window.liquidAjaxCart;

  const cartSuccess = document.querySelector('.js--cart-success');

  document.addEventListener('liquid-ajax-cart:request-end', function (e) {
    const { requestState, cart, previousCart, sections } = e.detail;

    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      let successTl = gsap.timeline();

      successTl
        .to(cartSuccess, { y: '120%', duration: 0.5, ease: 'power2.out' })
        .to(cartSuccess, { y: '0', duration: 0.5, ease: 'power2.out' }, '+=1.5');
    }
  });
}

const cartEl = document.querySelector('.module_cart-sidebar');
const cartToggle = document.querySelector('.js--cart-toggle');

if (cartEl && cartToggle) {
  document.addEventListener('click', (e) => {
    const isCart = cartEl.contains(e.target);
    const isToggle = cartToggle.contains(e.target);

    if (!isCart && !isToggle && cartEl.classList.contains('is--active')) {
      cartEl.classList.remove('is--active');
    }
  });

  cartToggle.addEventListener('click', (e) => {
    e.preventDefault();

    cartEl.classList.toggle('is--active');
  });
}

/* ======================================================================================= */
/* =============================================================================== FILTERS */
/* ======================================================================================= */

const filtersEl = document.querySelector('filters-wrap');
let filterLinks = document.querySelectorAll('.js--filter-toggle');

if (filtersEl) {
  filterLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      if (!filtersEl.classList.contains('is--active')) {
        gsap.to(filtersEl, {
          height: 'auto',
          duration: 0.5,
          ease: 'power2.out',
        });
        filtersEl.classList.add('is--active');
        link.classList.add('is--active');
      } else {
        gsap.to(filtersEl, {
          height: 0,
          duration: 0.5,
          ease: 'power2.out',
        });
        filtersEl.classList.remove('is--active');
        link.classList.remove('is--active');
      }
    });
  });
}

/* ======================================================================================= */
/* ================================================================================ EXTRAS */
/* ======================================================================================= */

/* -------------------------------------------------------- Requirement Checkbox */
const cartBtn = document.querySelector('.add-to-cart');
let productRestriction = document.querySelectorAll('.js--restriction');

if (cartBtn) {
  productRestriction.forEach((restriction) => {
    let checkbox = restriction.querySelector('input[type="checkbox"]');

    checkbox.addEventListener('change', (e) => {
      if (e.target.checked) {
        cartBtn.disabled = false;
        cartBtn.textContent = 'Add to Cart';
      } else {
        cartBtn.disabled = true;
        cartBtn.textContent = 'Not yet Queen';
      }
    });
  });
}

/* -------------------------------------------------------- Ticker Effect */
gsap.registerEffect({
  name: 'ticker',
  effect(targets, config) {
    buildTickers({
      targets: targets,
      clone:
        config.clone ||
        ((el) => {
          let clone = el.children[0].cloneNode(true);
          el.insertBefore(clone, el.children[0]);
          return clone;
        }),
    });
    function buildTickers(config, originals) {
      let tickers;
      if (originals && originals.clones) {
        originals.clones.forEach((el) => el && el.parentNode && el.parentNode.removeChild(el));
        originals.forEach((el, i) =>
          originals.inlineWidths[i] ? (el.style.width = originals.inlineWidths[i]) : el.style.removeProperty('width'),
        );
        tickers = originals;
      } else {
        tickers = config.targets;
      }
      const clones = (tickers.clones = []),
        inlineWidths = (tickers.inlineWidths = []);
      tickers.forEach((el, index) => {
        inlineWidths[index] = el.style.width;
        el.style.width = '10000px';
        el.children[0].style.display = 'inline-block';
        let width = el.children[0].offsetWidth,
          cloneCount = Math.ceil(window.innerWidth / width),
          right = el.dataset.direction === 'right',
          i;
        el.style.width = width * (cloneCount + 1) + 'px';
        for (i = 0; i < cloneCount; i++) {
          clones.push(config.clone(el));
        }
        gsap.fromTo(
          el,
          {
            x: right ? -width : 0,
          },
          {
            x: right ? 0 : -width,
            duration: width / 100 / parseFloat(el.dataset.speed || 1),
            repeat: -1,
            overwrite: 'auto',
            ease: 'none',
          },
        );
      });
      originals || window.addEventListener('resize', () => buildTickers(config, tickers));
    }
  },
});

gsap.effects.ticker('.js--ticker');
